/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Analyse_ButtonInputs */

const en_upload_analyse_button = /** @type {(inputs: Upload_Analyse_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Process Documents`)
};

const pt_br2_upload_analyse_button = /** @type {(inputs: Upload_Analyse_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processar documentos`)
};

/**
* | output |
* | --- |
* | "Process Documents" |
*
* @param {Upload_Analyse_ButtonInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const upload_analyse_button = /** @type {((inputs?: Upload_Analyse_ButtonInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Analyse_ButtonInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_analyse_button(inputs)
	return pt_br2_upload_analyse_button(inputs)
});